/*
 * OpenAPI definition
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: v0
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 *
 * Swagger Codegen version: 3.0.35
 *
 * Do not edit the class manually.
 *
 */
import {ApiClient} from '../ApiClient';
import {ChecklistQualitativeQuestionDTO} from './ChecklistQualitativeQuestionDTO';
import {ChecklistQuantitativeDriverDTO} from './ChecklistQuantitativeDriverDTO';

/**
 * The ChecklistCosoAmbitoDTO model module.
 * @module model/ChecklistCosoAmbitoDTO
 * @version v0
 */
export class ChecklistCosoAmbitoDTO {
  /**
   * Constructs a new <code>ChecklistCosoAmbitoDTO</code>.
   * @alias module:model/ChecklistCosoAmbitoDTO
   * @class
   */
  constructor() {
  }

  /**
   * Constructs a <code>ChecklistCosoAmbitoDTO</code> from a plain JavaScript object, optionally creating a new instance.
   * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
   * @param {Object} data The plain JavaScript object bearing properties of interest.
   * @param {module:model/ChecklistCosoAmbitoDTO} obj Optional instance to populate.
   * @return {module:model/ChecklistCosoAmbitoDTO} The populated <code>ChecklistCosoAmbitoDTO</code> instance.
   */
  static constructFromObject(data, obj) {
    if (data) {
      obj = obj || new ChecklistCosoAmbitoDTO();
      if (data.hasOwnProperty('id'))
        obj.id = ApiClient.convertToType(data['id'], 'Number');
      if (data.hasOwnProperty('position'))
        obj.position = ApiClient.convertToType(data['position'], 'Number');
      if (data.hasOwnProperty('title'))
        obj.title = ApiClient.convertToType(data['title'], 'String');
      if (data.hasOwnProperty('dummy'))
        obj.dummy = ApiClient.convertToType(data['dummy'], 'Boolean');
      if (data.hasOwnProperty('checklistQualitativeQuestions'))
        obj.checklistQualitativeQuestions = ApiClient.convertToType(data['checklistQualitativeQuestions'], [ChecklistQualitativeQuestionDTO]);
      if (data.hasOwnProperty('checklistQuantitativeDrivers'))
        obj.checklistQuantitativeDrivers = ApiClient.convertToType(data['checklistQuantitativeDrivers'], [ChecklistQuantitativeDriverDTO]);
      if (data.hasOwnProperty('tooltip'))
        obj.tooltip = ApiClient.convertToType(data['tooltip'], 'String');
    }
    return obj;
  }
}

/**
 * @member {Number} id
 */
ChecklistCosoAmbitoDTO.prototype.id = undefined;

/**
 * @member {Number} position
 */
ChecklistCosoAmbitoDTO.prototype.position = undefined;

/**
 * @member {String} title
 */
ChecklistCosoAmbitoDTO.prototype.title = undefined;

/**
 * @member {Boolean} dummy
 */
ChecklistCosoAmbitoDTO.prototype.dummy = undefined;

/**
 * @member {Array.<module:model/ChecklistQualitativeQuestionDTO>} checklistQualitativeQuestions
 */
ChecklistCosoAmbitoDTO.prototype.checklistQualitativeQuestions = undefined;

/**
 * @member {Array.<module:model/ChecklistQuantitativeDriverDTO>} checklistQuantitativeDrivers
 */
ChecklistCosoAmbitoDTO.prototype.checklistQuantitativeDrivers = undefined;

/**
 * @member {String} tooltip
 */
ChecklistCosoAmbitoDTO.prototype.tooltip = undefined;

